<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title" *ngIf="approval && approval.equipment.name">
      Deseja realmente aprovar o equipamento {{ approval.equipment.name }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="field-dialog__content">
    <form
      class="field-dialog__content__scroll p-24"
      fxLayout="column"
      name="form"
      [formGroup]="approveForm"
      fusePerfectScrollbar
    >
      <p>
        Caso deseje continuar com a <b>aprovação</b> deste equipamento, ele será adicionado a listagem oficial de
        equipamentos.
        <br />
        Esta solicitação será aprovada e o equipamento só poderá ser alterado com uma nova atualização da empresa
        <b>{{ approval.company.name }}</b
        >.
      </p>
      <span>Dados do equipamento:</span>
      <ul>
        <li>Número de série: {{ approval.equipment.number }}</li>
        <li>Nome do modelo: {{ approval.equipment.name }}</li>
        <li>Tipo de equipamento: {{ approval.equipment.type.name }}</li>
        <li>
          Endereço:
          <ul>
            <li>Localização: {{ approval.equipment.location.name }}</li>
            <li>Setor: {{ approval.equipment.locationSector?.name }}</li>
            <li>Ambiente: {{ approval.equipment.locationEnvironment?.name }}</li>
            <li>Endereço completo: {{ approval.equipment.location.address.formattedAddress }}</li>
          </ul>
        </li>
      </ul>
      <mat-form-field appearance="legacy" class="w-100-p pt-18">
        <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.NOTE' | translate }}</mat-label>
        <textarea
          matInput
          matTextareaAutosize
          matAutosizeMinRows="2"
          matAutosizeMaxRows="5"
          formControlName="message"
          autofocus
        ></textarea>
      </mat-form-field>
    </form>
  </div>

  <div class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <button
        class="field-background mr-16"
        mat-raised-button
        [disabled]="!this.approveForm.valid"
        (click)="acceptApproval()"
      >
        <span fxHide.xs>
          {{ 'APPROVALS_EQUIPMENTS.DIALOG.WANT_TO_APPROVE_EQUIPMENT' | translate }}
        </span>
        <span fxShow="false" fxShow.xs>
          {{ 'APPROVALS_EQUIPMENTS.DIALOG.APPROVE' | translate }}
        </span>
      </button>

      <button class="grey-400" mat-raised-button (click)="matDialogRef.close()">
        <span fxHide.xs>
          {{ 'APPROVALS_EQUIPMENTS.DIALOG.THINK_SO' | translate }}
        </span>
        <span fxShow="false" fxShow.xs>
          {{ 'APPROVALS_EQUIPMENTS.DIALOG.CANCEL' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
